import Image from 'next/image'

import { useIsTablet } from '@hooks/use-media-query'

import { overview, sectionsMobile } from './config'
import { Wrapper, Container, SectionItem, Title, Text } from './styles'
import { DescriptionProp } from './types'

const { sections } = overview

export function Overview() {
  const isTablet = useIsTablet()

  const render = isTablet ? sectionsMobile : sections

  return (
    <Wrapper>
      <Container>
        {render.map(({ id, title, text, image }: DescriptionProp) => (
          <SectionItem key={id}>
            {image && (
              <Image
                className="image"
                src={image?.src as string}
                width={image.width}
                height={image.height}
                alt={image?.alt as string}
                title={image.title}
              />
            )}
            <div>
              {title && <Title>{title}</Title>}
              {text && <Text>{text}</Text>}
            </div>
          </SectionItem>
        ))}
      </Container>
    </Wrapper>
  )
}
